import React, { useState, useEffect } from "react";

import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";

import { ExclamationCircleOutlined } from "@ant-design/icons";
import { SelectField } from "../../../atoms/FormElement";
import { BsPlusCircle, BsArrowCounterclockwise } from "react-icons/bs";

import { Row, Col, Button, Form, Typography, message, Space, Spin } from "antd";
import { useGeneralServiceRequest } from "./api/useGeneralServiceRequest";
import { useCategoryOptions } from "../hooks/useCategoryOptions";
import { usePostGeneralServiceRequest } from "./api/usePostGeneralServiceRequest";
import { useGeneralServiceRequestByOrgId } from "./api/useGeneralServicRequestByOrg";
const { Paragraph } = Typography;

const defaultValues: any = {
  name: "",
};

var _ = require("lodash");

export default (props) => {
  const { data, loading, error, refetch } = useGeneralServiceRequest();

  const [submited, setSubmited] = useState(false);
  const [isError, setisError] = useState(null);
  const [errorMessage, setErrorMessage] = useState(false);
  const [loader, setLoader] = useState(false);

  const commercialCategories = useCategoryOptions("commercial", data);
  const residentialCategories = useCategoryOptions("residential", data);

  const {
    control,
    formState: { errors },
    reset,
    handleSubmit,
    setValue,
    watch,
    setError,
    clearErrors,
  } = useForm({
    defaultValues,
  });

  const organizations = useSelector(
    (state: any) => state.organization.getOrganizationsDrop
  );

  useEffect(() => {
    if (props.selected) {
      const selectedOrganization = organizations.filter(
        (item) => item.value === props.selected.orgId
      )[0];
      setValue("name", selectedOrganization);
    } else reset();

    return () => {
      reset();
    };
  }, [props.selected, props]);

  const { postGeneralServiceRequest, loading: isLoading } =
    usePostGeneralServiceRequest();
  const { residentialOption, commercialOption } =
    useGeneralServiceRequestByOrgId(props.selected.orgId, isLoading);
  const onFinish = async (values) => {
    try {
      const response = await postGeneralServiceRequest(values);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <Form
      layout="vertical"
      onFinish={handleSubmit(onFinish)}
      className="bu_o_form"
    >
      {loader && !isError && (
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <Space size={24} className="w-100 text-center" direction="vertical">
              <Spin size="large" className="ag-fontSize32" />
            </Space>
          </Col>
        </Row>
      )}
      {!submited && !isError ? (
        <>
          <>
            <Row gutter={12}>
              <Col span={4}>
                <SelectField
                  isRequired={true}
                  fieldname="name"
                  control={control}
                  label="Organization"
                  selectOption={organizations}
                  validate={errors.name && "error"}
                  validMessage={errors.name && errors.name.message}
                  rules={{
                    required: "Please select organization",
                  }}
                  iProps={{
                    isDisabled: true,
                    placeholder: "Select organization",
                  }}
                />
              </Col>

              <Col span={10}>
                <SelectField
                  fieldname="commercialCategories"
                  isRequired={false}
                  control={control}
                  setValue={setValue}
                  label="Commercial Services"
                  selectOption={commercialCategories}
                  iProps={{
                    placeholder: "Select",
                    isMulti: true,
                  }}
                  valueGot={commercialOption ?? []}
                />
              </Col>

              <Col span={10}>
                <SelectField
                  fieldname="residentialCategories"
                  control={control}
                  label="Residential Services"
                  setValue={setValue}
                  selectOption={residentialCategories}
                  iProps={{
                    placeholder: "Select",
                    isMulti: true,
                  }}
                  valueGot={residentialOption ?? []}
                />
              </Col>
            </Row>
          </>

          <Row gutter={24} justify="space-between">
            <Col>
              <Button
                className="ag-error theme_grey_btn"
                htmlType="button"
                onClick={() => {
                  !props.selected && reset();
                  props.onCancel();
                }}
              >
                {<BsArrowCounterclockwise />} Back
              </Button>
            </Col>

            <Col>
              <Button className="ag-green-button theme_btn" htmlType="submit">
                {<BsPlusCircle />} Add
              </Button>
            </Col>
          </Row>
        </>
      ) : (
        isError && (
          <>
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Space
                  size={24}
                  className="w-100 text-center"
                  direction="vertical"
                >
                  <ExclamationCircleOutlined className="ag-fontSize32 ag-error" />
                  <Paragraph className="ag-error fontWeight600 mb-0 sentanceCase">
                    {errorMessage}
                  </Paragraph>
                </Space>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={24}>
                <Button
                  className="ag-gray-button-outline"
                  htmlType="button"
                  onClick={() => {
                    setSubmited(false);
                    setisError(false);
                  }}
                >
                  Back
                </Button>
              </Col>
            </Row>
          </>
        )
      )}
    </Form>
  );
};
